import React from "react"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import "./index.css"
import App from "./App"
import "./i18n"
import reportWebVitals from "./reportWebVitals"

Sentry.init({
  dsn: "https://4cdff33fad984b92b268a87a2186459e@o1396671.ingest.sentry.io/6720424",
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
})

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
